module.exports = __webpack_public_path__ + "img/prev-banner-basic-b1.289c5109.webp";